import buffer from 'buffer';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

global.Buffer = global.Buffer || buffer.Buffer;
